import { Icon } from '@chakra-ui/icon';
const Minus = props => <Icon {...props} data-sentry-element="Icon" data-sentry-component="Minus" data-sentry-source-file="Minus.tsx">
    <path d="M1.5 13.5h21a1.5 1.5 0 000-3h-21a1.5 1.5 0 000 3z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="Minus.tsx" />
  </Icon>;
Minus.displayName = 'MinusIcon';
export default Minus;